<template>
    <div class="content">
        <h3>清除登录信息</h3>
        <div class="login-box">
            <div>用户uid：{{ userid }}</div>
            <div>用户信息：{{ username }}</div>
            <div>用户openid：{{ openid }}</div>
            <div>用户手机号码：{{ mobile }}</div>
        </div>
        <div class="clear-btn">
            <van-button type="primary" block @click="clearUserInfo">清 除</van-button>
            <van-button type="default" block @click="goHome" class="home-btn">返回首页</van-button>
        </div>
    </div>
</template>
<script>
import store from "@/store";
import { Dialog } from  "vant";

export default{
    data()
    {
        return {
            userid:"",
            username:"",
            openid:"",
            mobile:"",
        }
    },
    inject:['reload'],
    created()
    {
        this.userid = this.$store.state.userid;
        this.username = this.$store.state.wx_info.username;
        this.openid = this.$store.state.wx_info.openid;
        this.mobile = this.$store.state.wx_info.mobile;
    },
    methods:{
        clearUserInfo()
        {
            Dialog.confirm({
                message: '是否清除以上登录信息',
            })
            .then(() => {
                store.commit('set_mobile',"");
                store.commit('set_userid',"");
                store.commit('set_openid',"");
                store.commit('set_username',"");
                store.commit('set_nickname',"");
                localStorage.clear()
                this.reload();
            })
            .catch(() => {
                    // on cancel
            });
        },
        goHome() {
            this.$router.push({name: 'index'});
        }
    }
}
</script>
<style lang="scss" scoped>
.content{
    margin: 1rem 1rem;
    line-height: 2;
    h3{
        font-size: 1rem;
        font-weight: bold;
    }
    .clear-btn{
        margin-top: 1rem;
        
        .home-btn {
            margin-top: 12px;
        }
    }
}
</style>